import { useState } from "react";

export default function useExpirationBoolean(timeout: number): [boolean, () => void] {
    const [state, setState] = useState(false);
    return [state, () => {
        setState(true);
        setTimeout(() => setState(false), timeout);
    }];
}
